import { FormCol } from "components/UI/Form/FormCol";
import { TextEditor } from "components/UI/TextEditor/TextEditor.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";

import { OfferEditGeneralFormData } from "../formSchema";

interface DescriptionSectionProps {
    control: Control<OfferEditGeneralFormData>;
}

export const DescriptionSection: FC<DescriptionSectionProps> = ({ control }) => {
    const { t: tFields } = usePaldockTranslation("forms.general-fields");

    return (
        <FormCol className="h-full">
            <FormItem control={control} name="description">
                <TextEditor
                    placeholder={tFields("description.placeholder")}
                    className={"border-none"}
                />
            </FormItem>
        </FormCol>
    );
};